import { useEffect, useState } from 'react';
import { authFetch } from '../utils/api';
import {
  getBrandOptions,
  tokenManager,
  type BrandCatalogOption,
} from '../utils/tokenManager';

export function useBrandOptions(): BrandCatalogOption[] {
  const [brandOptions, setBrandOptions] = useState<BrandCatalogOption[]>(() =>
    getBrandOptions()
  );

  useEffect(() => {
    let cancelled = false;
    authFetch('/api/admin/brands')
      .then((response) => response.json())
      .then((result) => {
        if (cancelled || result.code !== 0 || !Array.isArray(result.data)) {
          return;
        }
        tokenManager.setBrandCatalog(result.data);
        setBrandOptions(getBrandOptions());
      })
      .catch(() => {
        // Keep cached seed options when the brand registry is unreachable.
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return brandOptions;
}
